import { MediaInterface } from '@core/interfaces/media.interface';

export const isVideo = (media: MediaInterface): boolean => media.type?.startsWith('video/');
